module.exports = __webpack_public_path__ + "media/notification-success.c354ff15.mp3";